var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7051 1.82781C10.8986 1.68729 11.1437 1.52609 11.437 1.36553C12.2265 0.93347 13.3776 0.5 14.8162 0.5C16.303 0.5 17.788 1.0977 18.8972 2.28484C20.0098 3.47563 20.7051 5.21515 20.7051 7.4375C20.7051 10.7536 18.354 13.5247 16.0978 15.3948C14.9497 16.3464 13.7786 17.1049 12.8408 17.6276C12.372 17.8889 11.9543 18.0954 11.6202 18.2391C11.4538 18.3106 11.2998 18.3702 11.1654 18.4134C11.0562 18.4485 10.8805 18.5 10.7051 18.5C10.5297 18.5 10.354 18.4485 10.2448 18.4134C10.1104 18.3702 9.95638 18.3106 9.78998 18.2391C9.45588 18.0954 9.03818 17.8889 8.5694 17.6276C7.6316 17.1049 6.46047 16.3464 5.3124 15.3948C3.05622 13.5247 0.705078 10.7536 0.705078 7.4375C0.705078 5.21515 1.40036 3.47563 2.51297 2.28484C3.62216 1.0977 5.10716 0.5 6.59397 0.5C8.0326 0.5 9.18368 0.93347 9.97318 1.36553C10.2665 1.52609 10.5116 1.68729 10.7051 1.82781Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.2163a1c9a02f7d8fc5b6b7f9c4d41777.svg";
export { ForwardRef as ReactComponent };